import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccomodationGuard } from './auth-guards/accomodation-auth-guard';
import { AdministrationGuard } from './auth-guards/administration-auth-guard';
import { CommunicationGuard } from './auth-guards/communication-auth-guard';
import { eLearningGuard } from './auth-guards/elearning-auth-guard';
import { ExamsGuard } from './auth-guards/exams-auth-guarg';
import { FeesGuard } from './auth-guards/fees-auth-guard';
import { LibraryGuard } from './auth-guards/library-auth-guard';
import { LoggedInGuard } from './auth-guards/logged-in-auth-guard';
import { MaintenanceGuard } from './auth-guards/maintenance-auth-guard';
import { ReportsGuard } from './auth-guards/reports-auth-gaurd';
import { ResourceCentreGuard } from './auth-guards/resource-centre-auth-guard';
import { SettingsGuard } from './auth-guards/settings-auth-guard';
import { StudentsGuard } from './auth-guards/students-auth-guard';
import { StudentLoggedInGuard } from './auth-guards/student_portal_guard';
import { TimetableGuard } from './auth-guards/timetable-auth-guard';
import { TransportGuard } from './auth-guards/transport-auth-guard';

// Import Containers
import { DefaultLayoutComponent } from './containers';


import { LoginComponent } from './views/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  }
  ,
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Dominican Convent Primary School Harare'
    },
    children: [

      {
        path: 'students',
        canActivate: [AdministrationGuard],
        loadChildren: () => import('./views/students/students.module').then(m => m.StudentsModule)
      },
      {
        path: 'external-system-links',
        canActivate: [AdministrationGuard],
        loadChildren: () => import('./views/external-system-link/external-system-link.module').then(m => m.ExternalSystemLinkModule)
      },
      {
        path: 'student-centre',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/student-centre/student-centre.module').then(m => m.StudentCentreModule)
      },
      {
        path: 'users-teachers-resources',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/users-teachers-resources/users-teachers-resources.module').then(m => m.UsersTeachersResourcesModule)
      },
      {
        path: 'users-elibrary',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/users-elibrary/users-elibrary.module').then(m => m.UsersElibraryModule)
      },
      {
        path: 'school-calendar',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/all-school-calendar/all-school-calendar.module').then(m => m.AllSchoolCalendarModule)
      },
      {
        path: 'students-upload',
        canActivate: [AdministrationGuard],
        loadChildren: () => import('./views/students-upload/students-upload.module').then(m => m.StudentsUploadModule)
      },
      {
        path: 'student-id-cards',
        canActivate: [AdministrationGuard],
        loadChildren: () => import('./views/student-id-cards/student-id-cards.module').then(m => m.StudentIdCardsModule)
      },
      {
        path: 'fees-dashboard',
        canActivate: [FeesGuard],
        loadChildren: () => import('./views/fees-dashboard/fees-dashboard.module').then(m => m.FeesDashboardModule)
      },
      {
        path: 'fees-reports',
        canActivate: [FeesGuard],
        loadChildren: () => import('./views/fees-reports/fees-reports.module').then(m => m.FeesReportsModule)
      },
      {
        path: 'students-dashboard',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'students-overview',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/students-overview/students-overview.module').then(m => m.StudentsOverviewModule)
      },
      {
        path: 'attendance',
        canActivate: [StudentsGuard],
        loadChildren: () => import('./views/attendance/attendance.module').then(m => m.AttendanceModule)
      },
      {
        path: 'extra-curricular-reports',
        canActivate: [StudentsGuard],
        loadChildren: () => import('./views/extra-curricular-reports/extra-curricular-reports.module').then(m => m.ExtraCurricularReportsModule)
      },
      {
        path: 'extra-curricular-activities',
        canActivate: [StudentsGuard],
        loadChildren: () => import('./views/sporting-activities/sporting-activities.module').then(m => m.SportingActivitiesModule)
      },
      {
        path: 'extra-curricular-comments',
        canActivate: [StudentsGuard],
        loadChildren: () => import('./views/extra-curricular-comments/extra-curricular-comments.module').then(m => m.ExtraCurricularCommentsModule)
      },
      {
        path: 'disciplinary-records',
        canActivate: [StudentsGuard],
        loadChildren: () => import('./views/disciplinary-action/disciplinary-action.module').then(m => m.DisciplinaryActionModule)
      },
      {
        path: 'payments',
        canActivate: [FeesGuard],
        loadChildren: () => import('./views/payments/payments.module').then(m => m.PaymentsModule)
      },
      {
        path: 'advance-payments',
        canActivate: [FeesGuard],
        loadChildren: () => import('./views/advance-payments/advance-payments.module').then(m => m.AdvancePaymentsModule)
      },
      {
        path: 'billing',
        canActivate: [FeesGuard],
        loadChildren: () => import('./views/billing/billing.module').then(m => m.BillingModule)
      },
      {
        path: 'exams',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/exams/exams.module').then(m => m.ExamsModule)
      },
      {
        path: 'my-virtual-classes',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/teacher-virtial-classes/teacher-virtial-classes.module').then(m => m.TeacherVirtialClassesModule)
      },
      {
        path: 'course-work',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/course-work/course-work.module').then(m => m.CourseWorkModule)
      },
      {
        path: 'schemes-of-work',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/schemes-of-work/schemes-of-work.module').then(m => m.SchemesOfWorkModule)
      },
      {
        path: 'schemes-of-work-reviews',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/hod-schemes-of-work-review/hod-schemes-of-work-review.module').then(m => m.HodSchemesOfWorkReviewModule)
      },
      {
        path: 'lesson-planning',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/lesson-planning/lesson-planning.module').then(m => m.LessonPlanningModule)
      },
      {
        path: 'end-of-term-reports',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/end-of-term-report-comments/end-of-term-report-comments.module').then(m => m.EndOfTermReportCommentsModule)
      },
      {
        path: 'settings',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'system-administration',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/system-administration/system-administration.module').then(m => m.SystemAdministrationModule)
      },
      {
        path: 'levels',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/levels/levels.module').then(m => m.LevelsModule)
      },
      {
        path: 'classes',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/classes/classes.module').then(m => m.ClassesModule)
      },
      {
        path: 'virtual-classes',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/virtial-classes/virtial-classes.module').then(m => m.VirtialClassesModule)
      },
      {
        path: 'departments',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/departments/departments.module').then(m => m.DepartmentsModule)
      },
      {
        path: 'teachers',
        canActivate: [AdministrationGuard],
        loadChildren: () => import('./views/teachers/teachers.module').then(m => m.TeachersModule)
      },
      {
        path: 'school-terms',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/school-terms/school-terms.module').then(m => m.SchoolTermsModule)
      },
      {
        path: 'subjects',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/subjects/subjects.module').then(m => m.SubjectsModule)
      },
      {
        path: 'grading-scales',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/grading-scales/grading-scales.module').then(m => m.GradingScalesModule)
      },
      {
        path: 'planning-reports',
        canActivate: [MaintenanceGuard],
        loadChildren: () => import('./views/planning-reports/planning-reports.module').then(m => m.PlanningReportsModule)
      },
      {
        path: 'users',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'home',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'types-and-categories',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/types-and-categories/types-and-categories.module').then(m => m.TypesAndCategoriesModule)
      },
      {
        path: 'elibrary',
        canActivate: [ResourceCentreGuard],
        loadChildren: () => import('./views/elibrary/elibrary.module').then(m => m.ElibraryModule)
      },
      {
        path: 'teachers-resources',
        canActivate: [ResourceCentreGuard],
        loadChildren: () => import('./views/teachers-resources/teachers-resources.module').then(m => m.TeachersResourcesModule)
      },
      {
        path: 'elibrary-categories',
        canActivate: [ResourceCentreGuard],
        loadChildren: () => import('./views/elibrary-categories/elibrary-categories.module').then(m => m.ElibraryCategoriesModule)
      },
      {
        path: 'elibrary-dashboard',
        canActivate: [ResourceCentreGuard],
        loadChildren: () => import('./views/elibrary-dashboard/elibrary-dashboard.module').then(m => m.ElibraryDashboardModule)
      },
      {
        path: 'reports-centre',
        canActivate: [ReportsGuard],
        loadChildren: () => import('./views/reports-centre/reports-centre.module').then(m => m.ReportsCentreModule)
      },
      {
        path: 'reports-centre-lists',
        canActivate: [ReportsGuard],
        loadChildren: () => import('./views/reports-centre-lists/reports-centre-lists.module').then(m => m.ReportsCentreListsModule)
      },
      {
        path: 'system-calendar',
        canActivate: [ReportsGuard],
        loadChildren: () => import('./views/system-calendar/system-calendar.module').then(m => m.SystemCalendarModule)
      },
      {
        path: 'payment-plans',
        canActivate: [FeesGuard],
        loadChildren: () => import('./views/payment-plans/payment-plans.module').then(m => m.PaymentPlansModule)
      },
      {
        path: 'hostels',
        canActivate: [AccomodationGuard],
        loadChildren: () => import('./views/hostels/hostels.module').then(m => m.HostelsModule)
      },
      {
        path: 'accomodation-dashboard',
        canActivate: [AccomodationGuard],
        loadChildren: () => import('./views/accomodation-dashboard/accomodation-dashboard.module').then(m => m.AccomodationDashboardModule)
      },
      {
        path: 'accomodation-settings',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/accomodation-settings/accomodation-settings.module').then(m => m.AccomodationSettingsModule)
      },
      {
        path: 'accomodation-check-in',
        canActivate: [AccomodationGuard],
        loadChildren: () => import('./views/accomodation-check-in/accomodation-check-in.module').then(m => m.AccomodationCheckInModule)
      },
      {
        path: 'accomodation-check-out',
        canActivate: [AccomodationGuard],
        loadChildren: () => import('./views/accomodation-check-out/accomodation-check-out.module').then(m => m.AccomodationCheckOutModule)
      },
      {
        path: 'accomodation-comments',
        canActivate: [AccomodationGuard],
        loadChildren: () => import('./views/accomodation-student-comments/accomodation-student-comments.module').then(m => m.AccomodationStudentCommentsModule)
      },
      {
        path: 'accomodation-reports',
        canActivate: [AccomodationGuard],
        loadChildren: () => import('./views/accomodation-reports/accomodation-reports.module').then(m => m.AccomodationReportsModule)
      },
      {
        path: 'report-scheduler',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/report-scheduler/report-scheduler.module').then(m => m.ReportSchedulerModule)
      },
      {
        path: 'communication-dashboard',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-dashboard/communication-dashboard.module').then(m => m.CommunicationDashboardModule)
      },
      {
        path: 'emails',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-emails/communication-emails.module').then(m => m.CommunicationEmailsModule)
      },
      {
        path: 'smss',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-smss/communication-smss.module').then(m => m.CommunicationSmssModule)
      },
      {
        path: 'house-points',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/student-points/student-points.module').then(m => m.StudentPointsModule)
      },
      {
        path: 'notices',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-notices/communication-notices.module').then(m => m.CommunicationNoticesModule)
      },
      {
        path: 'letters',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-letters/communication-letters.module').then(m => m.CommunicationLettersModule)
      },
      {
        path: 'mobile-app-documents',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-mobile-app-documents/communication-mobile-app-documents.module').then(m => m.CommunicationMobileAppDocumentsModule)
      },
      {
        path: 'notifications',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/communication-notifications/communication-notifications.module').then(m => m.CommunicationNotificationsModule)
      },
      {
        path: 'instant-messages',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/messaging/messaging.module').then(m => m.MessagingModule)
      },
      {
        path: 'enquiries',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/enquiries/enquiries.module').then(m => m.EnquiriesModule)
      },
      {
        path: 'admin-school-calendar',
        canActivate: [CommunicationGuard],
        loadChildren: () => import('./views/school-calendar/school-calendar.module').then(m => m.SchoolCalendarModule)
      },
      {
        path: 'exams-dashboard',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/exams-dashboard/exams-dashboard.module').then(m => m.ExamsDashboardModule)
      },
      {
        path: 'comments-bank',
        canActivate: [ExamsGuard],
        loadChildren: () => import('./views/comments-bank/comments-bank.module').then(m => m.CommentsBankModule)
      },
      {
        path: 'transport-settings',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/transport-settings/transport-settings.module').then(m => m.TransportSettinsModule)
      },
      {
        path: 'library-settings',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/library-settings/library-settings.module').then(m => m.LibrarySettingsModule)
      },
      {
        path: 'online-exams-policy',
        canActivate: [SettingsGuard],
        loadChildren: () => import('./views/online-exams-policy/online-exams-policy.module').then(m => m.OnlineExamsPolicyModule)
      },
      {
        path: 'drivers',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/drivers/drivers.module').then(m => m.DriversModule)
      },
      {
        path: 'vehicles',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/vehicles/vehicles.module').then(m => m.VehiclesModule)
      },
      {
        path: 'routes',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/routes/routes.module').then(m => m.RoutesModule)
      },
      {
        path: 'pick-up-points',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/pick-up-points/pick-up-points.module').then(m => m.PickUpPointsModule)
      },
      {
        path: 'transport-dashboard',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/transport-dashboard/transport-dashboard.module').then(m => m.TransportDashboardModule)
      },
      {
        path: 'transport-students',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/transport-students/transport-students.module').then(m => m.TransportStudentsModule)
      },
      {
        path: 'transport-reports',
        canActivate: [TransportGuard],
        loadChildren: () => import('./views/transport-reports/transport-reports.module').then(m => m.TransportReportsModule)
      },
      {
        path: 'admin-exam-timetable',
        canActivate: [TimetableGuard],
        loadChildren: () => import('./views/exam-timetable/exam-timetable.module').then(m => m.ExamTimetableModule)
      },
      {
        path: 'exam-timetable',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/all-exam-timetable/all-exam-timetable.module').then(m => m.AllExamTimetableModule)
      },
      {
        path: 'admin-lesson-timetable',
        canActivate: [TimetableGuard],
        loadChildren: () => import('./views/lesson-timetable/lesson-timetable.module').then(m => m.LessonTimetableModule)
      },
      {
        path: 'lesson-timetable',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/all-lesson-timetable/all-lesson-timetable.module').then(m => m.AllLessonTimetableModule)
      },
      {
        path: 'generate-timetable',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/generate-lessons-timetable/generate-lessons-timetable.module').then(m => m.GenerateLessonsTimetableModule)
      },
      {
        path: 'timetable-dashboard',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/timetable-dashboard/timetable-dashboard.module').then(m => m.TimetableDashboardModule)
      },
      {
        path: 'lessons-status',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/lessons-status/lessons-status.module').then(m => m.LessonsStatusModule)
      },
      {
        path: 'timetable-conflicts',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/timetable-conflicts/timetable-conflicts.module').then(m => m.TimetableConflictsModule)
      },
      {
        path: 'teacher-timetable',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/teacher-timetable/teacher-timetable.module').then(m => m.TeacherTimetableModule)
      },
      {
        path: 'noticeboard',
        canActivate: [LoggedInGuard],
        loadChildren: () => import('./views/noticeboard/noticeboard.module').then(m => m.NoticeboardModule)
      },
      {
        path: 'live-lessons',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/live-lessons-streaming/live-lessons-streaming.module').then(m => m.LiveLessonsStreamingModule)
      },
      {
        path: 'assignments',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/assignments/assignments.module').then(m => m.AssignmentsModule)
      },
      {
        path: 'e-lessons',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/elessons/elessons.module').then(m => m.ElessonsModule)
      },
      {
        path: 'e-lessons-exercises',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/elessons-exercises/elessons-exercises.module').then(m => m.ElessonsExercisesModule)
      },
      {
        path: 'e-learning-exams',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/elearning-exams/elearning-exams.module').then(m => m.ElearningExamsModule)
      },
      {
        path: 'e-learning-scheduled-exams',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/elearning-scheduled-exams/elearning-scheduled-exams.module').then(m => m.ElearningScheduledExamsModule)
      },
      {
        path: 'e-learning-reports',
        canActivate: [eLearningGuard],
        loadChildren: () => import('./views/elearning-reports/elearning-reports.module').then(m => m.ElearningReportsModule)
      },
      {
        path: 'library-categories',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-categories/library-categories.module').then(m => m.LibraryCategoriesModule)
      },
      {
        path: 'libraries',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/libraries/libraries.module').then(m => m.LibrariesModule)
      },
      {
        path: 'library-books',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-books/library-books.module').then(m => m.LibraryBooksModule)
      },
      {
        path: 'check-out-books',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-check-out-books/library-check-out-books.module').then(m => m.LibraryCheckOutBooksModule)
      },
      {
        path: 'check-in-books',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-check-in-books/library-check-in-books.module').then(m => m.LibraryCheckInBooksModule)
      },
      {
        path: 'reserve-books',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-reserve-books/library-reserve-books.module').then(m => m.LibraryReserveBooksModule)
      },
      {
        path: 'library-book-losses',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-book-losses/library-book-losses.module').then(m => m.LibraryBookLossesModule)
      },
      {
        path: 'library-penalties',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-penalties/library-penalties.module').then(m => m.LibraryPenaltiesModule)
      },
      {
        path: 'library-dashboard',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-dashboard/library-dashboard.module').then(m => m.LibraryDashboardModule)
      },
      {
        path: 'library-reports',
        canActivate: [LibraryGuard],
        loadChildren: () => import('./views/library-reports/library-reports.module').then(m => m.LibraryReportsModule)
      },


      //Student portal routes
      {
        path: 'sp-elibrary',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/e-library/e-library.module').then(m => m.SPELibraryModule)
      },
      {
        path: 'sp-assignments',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/assignments/assignments.module').then(m => m.SPAssignmentsModule)
      },
      {
        path: 'sp-notices',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/notices/notices.module').then(m => m.SPNoticesModule)
      },
      {
        path: 'sp-exams',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/exams/exams.module').then(m => m.SPExamsModule)
      },
      {
        path: 'sp-lesson-status',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/lesson-status/lesson-status.module').then(m => m.SPLessonStatusModule)
      },
      {
        path: 'sp-timetable',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/timetable/timetable.module').then(m => m.SPTimetableModule)
      },
      {
        path: 'sp-dashboard',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/dashboard/dashboard.module').then(m => m.SPDashboardModule)
      },
      {
        path: 'sp-lesson-plans',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/sp-schemes-of-work/sp-schemes-of-work.module').then(m => m.SpSchemesOfWorkModule)
      },
      {
        path: 'sp-transactions',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/transactions/transactions.module').then(m => m.SPTransactionsModule)
      },
      {
        path: 'sp-reports',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/reports/reports.module').then(m => m.SPReportsModule)
      },
      {
        path: 'sp-details',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/details/details.module').then(m => m.SPDetailsModule)
      },
      {
        path: 'sp-online-exams',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/online-exams/online-exams.module').then(m => m.SPOnlineExamsModule)
      },
      {
        path: 'sp-online-exam',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/online-exam/online-exam.module').then(m => m.SPOnlineExamModule)
      },
      {
        path: 'sp-live-lessons',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/live-lessons/live-lessons.module').then(m => m.SPLiveLessonsModule)
      },
      {
        path: 'sp-live-lesson',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/live-lesson/live-lesson.module').then(m => m.SPLiveLessonModule)
      },
      {
        path: 'sp-exams-timetable',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/exams-timetable/exams-timetable.module').then(m => m.SPExamsTimetableModule)
      },
      {
        path: 'sp-school-calendar',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/school-calendar/school-calendar.module').then(m => m.SPSchoolCalendarModule)
      },
      {
        path: 'sp-home',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/home/home.module').then(m => m.SPHomeModule)
      },
      {
        path: 'sp-online-tutorials',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/online-tutorials/online-tutorials.module').then(m => m.SPOnlineTutorialsModule)
      },
      {
        path: 'sp-online-tutorial-exercise',
        canActivate: [StudentLoggedInGuard],
        loadChildren: () => import('./views/student-portal/online-tutorial-exercise/online-tutorial-exercise.module').then(m => m.SPOnlineTutorialExerciseModule)
      },
    ]
  },
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
